import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  buttonContainer: {
    height: 'auto',
  },
  content: {
    backgroundColor: '#fff',
  },
  container: {
    flexDirection:'row',
    alignItems:'center',
    justifyContent:'center',
  },
});
